<template>
  <div>
    <div v-role="['1']" style="margin-bottom: 20px">
      <h2>数据中心</h2>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card class="box-card" style="background: white">
            <div>
              <h3>最新赛事</h3>
              <div>{{ matchSummary.plan + matchSummary.going }}</div>
              <el-progress :percentage="0"></el-progress>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6"
          ><el-card class="box-card" style="background: white">
            <h3>预备报名</h3>
            <div>{{ matchSummary.plan }}</div>
            <el-progress :percentage="0"></el-progress> </el-card
        ></el-col>
        <el-col :span="6"
          ><el-card class="box-card" style="background: white">
            <h3>正在进行</h3>
            <div>{{ matchSummary.going }}</div>
            <el-progress :percentage="0"></el-progress> </el-card
        ></el-col>
        <el-col :span="6"
          ><el-card class="box-card" style="background: white">
            <h3>赛事后续</h3>
            <div>{{ matchSummary.finished }}</div>
            <el-progress :percentage="0"></el-progress> </el-card
        ></el-col>
      </el-row>
    </div>
    <el-row>
 <el-col>
    <i class="el-icon-bell"></i>最新公告：</el-col>
    <el-col>
      <el-carousel height="30px" direction="vertical" autoplay :interval="3000" indicator-position="none">
      <el-carousel-item v-for="item in newsList" :key="item.id">
         <el-link @click="gotoArticle(item.id)">{{ item.title }}</el-link>
      </el-carousel-item>
    </el-carousel>
</el-col>
    </el-row>
   
    <el-row :gutter="20">
      <el-col :span="24">
        <el-row>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <strong>比赛列表</strong>
              <el-button
                style="float: right; padding: 3px 0"
                @click="gotoMatchList"
                type="text"
                >查看更多</el-button
              >
            </div>
            <el-table :data="mathList" style="width: 100%">
              <el-table-column prop="name" align="center" show-overflow-tooltip label="比赛名称">
                  <template slot-scope="scope">
                      <div class="wrap-text cell" @click="gotoChart(scope.row.matchId)">
            {{ scope.row.name!=null?scope.row.name.replaceAll('\\n','\n'):""}}</div>
         
                  </template>
              </el-table-column>
              <el-table-column prop="address" align="center" label="比赛地点">
              </el-table-column>
              <el-table-column
                prop="startTime"
                align="center"
                label="比赛时间"
                :formatter="startTimeFormatter"
              >
              </el-table-column>
              <el-table-column prop="status" align="center" label="比赛状态" :formatter="statusFormatter">
              </el-table-column>
              <el-table-column
                prop="registrationEndTime"
                align="center"
                label="报名截止时间"
                :formatter="startTimeFormatter2">
              </el-table-column>
              <el-table-column prop="operation" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    :title="scope.row"
                    @click="gotoMatch(scope.row)"
                    class="btn"
                    size="small"
                    >进入比赛</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>关于我们</span>
              </div>
              <div>
                重庆靓舞赛事团队，拥有多年国标舞（体育舞蹈）专业赛事服务经验，业务范围涵盖赛事记分、赛事检录及舞台灯光设计。我们将以专业的服务、精细的执行以及优质的口碑，竭诚为国标舞（体育舞蹈）赛事提供优质的赛事执行和服务！
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>联系我们</span>
              </div>
              <div>
                联系电话：18983893524（微信同号）/17723544217（微信同号）<br />
                QQ：1156939105/1150952509 邮箱：1156939105@qq.com<br />
                地址：重庆市南岸区江南大道12号亿象城众创空间
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      <!--<el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>最新消息</span>
            <el-button style="float: right; padding: 3px 0" type="text"
              >查看更多</el-button
            >
          </div>
        </el-card>
      </el-col>-->
    </el-row>
  </div>
</template>
<script>
import MATCHAPI from '../apis/match'
import moment from 'moment'
import NewsApi from '../apis/news'

export default {
  data () {
    return {
      mathList: null,
      newsList: [],
      matchSummary: {},
      aboutUs: null,
    }
  },
  methods: {
    statusFormatter(row, column, cellValue, index){
      if(cellValue=="1")
      {
        return '正在报名中';
      }
      else if(cellValue=='2')
      {
        return '准备比赛';
      }
      else if(cellValue=='3')
      {
        return '比赛结束';
      }
    },
    gotoArticle (id) {
      this.$router.push({
        path: '/newsdetail', query: { id: id }
      })
    },  
      startTimeFormatter2: function (row, column) {
      var date = row.registrationEndTime
      if (date == undefined) { return '' }      
      return moment(date).format("YYYY-MM-DD")
    },
    gotoMatchList () {
      this.$router.push({
        path: '/matches'
      })
    },
    gotoMatch (row) {
      this.$router.push({
        path: '/matchdetail',
        query: { matchId: row.matchId }
      })
    },
    startTimeFormatter: function (row, column) {
      var date = row.startTime
      if (date == undefined) { return '' }
      var enddate = row.endTime
      if (enddate == undefined) { return '' }
      return moment(date).format("YYYY-MM-DD") + '至' + moment(enddate).format("YYYY-MM-DD")
    },
    getMatches () {
      MATCHAPI.getList({
        page: 1, pageSize: 10
      }).then(resp => {
        this.mathList = resp.result.data
      })
    }
  },
  mounted () {
    this.getMatches()
    NewsApi.select().then(res => {
      this.newsList = res.result
    })
    MATCHAPI.summary().then(res => { this.matchSummary = res.result })
  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-card__header {
  text-align: left !important;
}
.wrap-text {
  white-space: pre-line !important;
  word-wrap: break-word;
}
h2 {
  text-align: left;
  margin: 0px 0px 10px 0px;
}
</style>


// WEBPACK FOOTER //
// src/views/Index.vue